import { gql } from '@apollo/client';

export * from './appProtectionAssuranceSummary.query.generated';

export const APP_PROTECTION_ASSURANCE_SUMMARY = gql`
  query appProtectionAssuranceSummary($owned: Boolean) {
    appProtectionAssuranceSummary(owned: $owned) {
      certificationCertifiedCount
      certificationCertifiedPercentage
      certificationValidatedCount
      certificationValidatedPercentage
      certificationVerifiedCount
      certificationVerifiedPercentage
      totalProtectionsCount
      backupsCount
      custodianProfilesCount
      escrowsCount
    }
  }
`;
